import { gql } from '@apollo/client';

export const DELETE_PREREQUISITE_MUTATION = gql`
    mutation deletePrerequisiteSet( $input:DeletePrerequisiteSetInput! ){
        Result: deletePrerequisiteSet( input:$input ) {
            affectedRows
        }
    }
`;

